// extracted by mini-css-extract-plugin
export default {"warning":"DeletePopup_warning__QjDjL","button":"DeletePopup_button__qhcBG"};